import { ComponentClass, createContext, FunctionComponent, ReactNode } from "react";

export type AuthorizationContextValue = {
  isAuthorizing: boolean,
  isSuperAdmin: boolean,
  permissions: string[],
  redirectUrl: string,
  accessDeniedStub: ReactNode | FunctionComponent<any> | ComponentClass<any>
}

const defaultAuthorizationContext: AuthorizationContextValue = {
  isAuthorizing: false,
  isSuperAdmin: true,
  permissions: [],
  redirectUrl: "/",
  accessDeniedStub: <div>Access denied</div>,
};

Object.freeze(defaultAuthorizationContext);

export const AuthorizationContext = createContext<AuthorizationContextValue>(defaultAuthorizationContext);

export default AuthorizationContext;
